import awsAccount from './aws-accounts'

export default {
  awsAccount
}
